import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "message", "description", "iconName", "errorLink", "className", "style"];
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { EmbersLink } from '../../../link';
import { EmbersStatusIcon } from '../../../statusIcon/statusIcon';
import { ROOT_PREFIX, tableMessageTheme } from './tableMessageStyles';
import { useIntl } from 'react-intl';
import classnames from 'classnames';
export var EmbersTableMessageStatus = /*#__PURE__*/function (EmbersTableMessageStatus) {
  EmbersTableMessageStatus["ERROR"] = "error";
  EmbersTableMessageStatus["NOT_FOUND"] = "info";
  EmbersTableMessageStatus["NOT_EXISTED"] = "alert";
  return EmbersTableMessageStatus;
}({});
export var TableMessage = function TableMessage(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? EmbersTableMessageStatus.NOT_FOUND : _ref$type,
    message = _ref.message,
    description = _ref.description,
    iconName = _ref.iconName,
    errorLink = _ref.errorLink,
    className = _ref.className,
    style = _ref.style,
    props = _objectWithoutProperties(_ref, _excluded);
  var intl = useIntl();
  var _iconName = type === EmbersTableMessageStatus.NOT_EXISTED ? 'icon-block' : iconName;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: tableMessageTheme
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classnames("".concat(ROOT_PREFIX, "-root"), className),
    style: style
  }, /*#__PURE__*/React.createElement(EmbersStatusIcon, _extends({
    variant: type === EmbersTableMessageStatus.ERROR ? 'filled' : 'outline',
    type: type,
    iconName: _iconName
  }, props), message), /*#__PURE__*/React.createElement(Typography, null, type === EmbersTableMessageStatus.ERROR && errorLink ? intl.formatMessage({
    id: 'embers.table.errorMessage',
    defaultMessage: 'Try refreshing to resolve this issue. If it happens again, contact {prometheanSupport}.'
  }, {
    prometheanSupport: /*#__PURE__*/React.createElement(EmbersLink, {
      style: {
        fontSize: 16
      },
      href: errorLink,
      target: "_blank"
    }, intl.formatMessage({
      id: 'embers.support',
      defaultMessage: 'Promethean Support'
    }))
  }) : description)));
};